import { Link } from "react-router-dom";
import { useReveal } from "../lib/useReveal";
import { ArrowRight, Quote } from "lucide-react";

const FOUNDER = {
    name: 'Chris "Toon"',
    role: "Founder",
    portrait: `${process.env.PUBLIC_URL || ""}/clientpic.jpg`,
};

export default function FounderNote() {
    const ref = useReveal();

    return (
        <section
            ref={ref}
            id="founder"
            data-testid="founder-note-section"
            className="py-20 md:py-24 bg-background border-b"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="reveal rounded-[2rem] border bg-card overflow-hidden shadow-sm">
                    <div className="grid lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)]">
                        <div className="relative min-h-[18rem] lg:min-h-full">
                            <img
                                src={FOUNDER.portrait}
                                alt={`${FOUNDER.name}, founder of Genesis Recovery AI`}
                                className="absolute inset-0 h-full w-full object-cover object-top"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-slate-950/10 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-transparent lg:to-slate-950/20" />
                            <div className="absolute inset-x-0 bottom-0 p-6 lg:hidden">
                                <div className="text-xs uppercase tracking-[0.18em] text-emerald-300 font-semibold">
                                    From the Founder
                                </div>
                                <div className="mt-1 text-xl font-semibold text-white">{FOUNDER.name}</div>
                            </div>
                        </div>

                        <div className="p-8 md:p-10 lg:p-12 flex flex-col justify-center">
                            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold w-fit mb-5">
                                From the Founder
                            </div>
                            <Quote className="w-8 h-8 text-primary/25 mb-4" aria-hidden="true" />
                            <blockquote className="text-lg md:text-xl text-foreground leading-relaxed">
                                When I finally asked for help in 2005, my first thought walking into
                                Tarzana was, &ldquo;these people look really f*ed up — let&apos;s get out
                                of here.&rdquo; My friend looked at me and said, &ldquo;Toon, you look
                                worse.&rdquo; That hit hard. I stayed. I&apos;ve spent every year since
                                trying to help others find what I found at Genesis. This app is that work.
                            </blockquote>
                            <div className="mt-6 font-semibold text-foreground">
                                — {FOUNDER.name}, {FOUNDER.role}
                            </div>
                            <Link
                                to="/my-story"
                                data-testid="founder-note-read-story-link"
                                className="mt-8 inline-flex items-center gap-2 text-primary font-semibold hover:gap-3 transition-all w-fit"
                            >
                                Read my story
                                <ArrowRight className="w-4 h-4" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
